export const RBAC_PRODUCT_AREAS = {
  ADMIN_AND_COMPANY_SETTING: 'administrative',
  COACHING: 'coaching',
  FEEDBACK: 'feedback',
  QA: 'qa',
  SOCIAL: 'social',
  QA_CALIBRATION: 'qa_calibration',
  QA_APPEAL: 'qa_appeal',
} as const;

export const RBAC_PRODUCT_AREAS_WITH_DEFAULT = {
  ...RBAC_PRODUCT_AREAS,
  DEFAULT: 'default',
} as const;
